import { get, put, del, post } from './requests.js'

export const getMediaMeasurementCampaigns = (id) =>
  get(['media-measurement-campaigns', ...(id ? [id] : [])], { transformPayload: true })

export const createMediaMeasurementCampaign = (payload) =>
  post('media-measurement-campaigns', { transformPayload: true }, payload)

export const updateMediaMeasurementCampaigns = (id, payload) =>
  put(['media-measurement-campaigns', ...(id ? [id] : [])], { transformPayload: true }, payload)

export const deleteMediaMeasurementCampaigns = (id) =>
  del(['media-measurement-campaigns', ...(id ? [id] : [])], {})

export const getEnumCreatedBy = () =>
  get(['media-measurement-campaigns', 'enum', 'created_by.email'], {})
